import { render, staticRenderFns } from "./Depenses.vue?vue&type=template&id=70b76f79&scoped=true"
import script from "./Depenses.vue?vue&type=script&lang=js"
export * from "./Depenses.vue?vue&type=script&lang=js"
import style0 from "./Depenses.vue?vue&type=style&index=0&id=70b76f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b76f79",
  null
  
)

export default component.exports